/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load your practice conversations. Please try again in a moment." |
*
* @param {Practice_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_failed = /** @type {((inputs?: Practice_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je oefengesprekken niet laden. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger vos entretiens d'entraînement. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load your practice conversations. Please try again in a moment.")
});